import { Box } from '@rbilabs/universal-components';

import { spacing } from 'styles/constants';

export const CloseButtonWrapper = Box.withConfig({ position: 'absolute', right: spacing.$1 });
